// extracted by mini-css-extract-plugin
export default {"backHome":"Home_backHome__85mS-"};